import { ALERT_STATES, ALERT_VIEWS } from '@baseline/shared';

import type { AlertFilter } from '../api/queries.js';
import type { AlertState, AlertView, Severity } from '@baseline/shared';

// The Alerts list filter lives in the URL (`/alerts?view=waiting&severity=2`), so the
// dashboard's drill-through links, the detail stepper and the back link all share it.

export const NO_FILTER: AlertFilter = {
  view: 'all',
  severity: null,
  assemblyId: null,
  state: null,
};

export function readFilter(params: URLSearchParams): AlertFilter {
  const view = params.get('view');
  const sev = params.get('severity');
  const state = params.get('state');
  return {
    view: (ALERT_VIEWS as readonly string[]).includes(view ?? '') ? (view as AlertView) : 'all',
    severity: sev === '0' || sev === '1' || sev === '2' ? (Number(sev) as Severity) : null,
    assemblyId: params.get('assemblyId'),
    state: (ALERT_STATES as readonly string[]).includes(state ?? '') ? (state as AlertState) : null,
  };
}

export function isFiltered(f: AlertFilter): boolean {
  return f.view !== 'all' || f.severity !== null || f.assemblyId !== null || f.state !== null;
}
